import React from "react";
import "../App.css";
import HomeColumn from "../Components/HomeColumn/HomeColumn";
import handsheart from "../images/home-icons/handsheart.png";
import holdhands from "../images/home-icons/holdhands.png";
import prayinghands from "../images/home-icons/prayingicon.png";
import { Row, Col } from "react-bootstrap";
import logo from "../images/pohlogo.png";
import homeImage from "../images/poh-10-years.PNG";
import { Events } from "../data/events/events";
import UpcomingEvents from "../Components/UpcomingEvents";
import Phases from "../Components/Phases";
import { Link } from "react-router-dom";
import homeVideo from "../videos/test.mp4";
import { FaArrowRight } from "react-icons/fa";
import { Helmet } from "react-helmet";
import {
    PRODUCTS,
    TOWEL_PRODUCT_ID,
    TUMBLER_COLOR_PRODUCT_ID,
    MUG_PRODUCT_ID,
} from "../data/store/products.const";
import ProductCard from "../Components/Store/ProductCard";

function Home() {
    const featuredProducts = [
        TOWEL_PRODUCT_ID,
        TUMBLER_COLOR_PRODUCT_ID,
        MUG_PRODUCT_ID,
    ];

    const homeColumn = [
        {
            imageLink: handsheart,
            title: "Volunteer",
            paragraph:
                "Volunteering changes lives. You may volunteer by working events, making calls to potential donors, sorting donated goods and other tasks.",
            alt: "hands with heart",
            link: "/contact",
        },
        {
            imageLink: holdhands,
            title: "Get Help",
            paragraph:
                "Platform of Hope distributes material essentials, non-perishables while providing financial assistance. Applications are accepted when funding is available.",
            alt: "holding hands",
            link: "/gethelp",
        },
        {
            imageLink: prayinghands,
            title: "Donate",
            paragraph:
                "Platform of Hope greatly appreciates support of any kind. The quickest, most efficient way to give is through monetary donations.",
            alt: "praying hands",
            link: "/donate",
        },
    ];

    return (
        <div className="home">
            <Helmet>
                <title>Platform of Hope</title>
            </Helmet>
            <div className="home-top">
                <div>
                    <h1>Helping One Family At A Time.</h1>
                    <p>
                        Platform of Hope is an initiative designed to feed,
                        house, clothe, and council underserved families while
                        empowering and transforming lives of the economically
                        underserved. We successfully provide support and restore
                        lives of homeless families in Atlanta, Georgia and
                        surrounding counties. Platform of Hope facilitates in
                        local correctional facilities then partners released
                        offenders with employers for reemployment.
                    </p>
                    <Link to="/about">
                        <button>Learn More</button>
                    </Link>
                </div>
                <img src={logo} alt="logo" />
            </div>
            <img
                className="home-image"
                src={homeImage}
                alt="Platform of Hope"
            />
            <div className="home-section">
                <div className="store-advertisement-container">
                    <Link to="/store" className="store-advertisement-title">
                        <h2>Check out our new Platform of Hope Store</h2>
                        <FaArrowRight size={30} />
                    </Link>
                    <p>See more items like the featured products below</p>
                </div>
                <div className="column-container">
                    {Object.entries(PRODUCTS)
                        .filter(([key, value]) =>
                            featuredProducts.includes(key),
                        )
                        .map(([productId, product]) => (
                            <ProductCard
                                isFeatured={true}
                                key={productId}
                                cost={product.cost}
                                imgSrc={product.img}
                                name={product.name}
                                productId={productId}
                            />
                        ))}
                </div>
            </div>

            <div className="featuredEventsContainer">
                <div className="featuredEvents">
                    <Row>
                        <Col xl={8} lg={8} md={12}>
                            <div className="upcomingEvents d-flex align-items-center justify-content-center">
                                <Row>
                                    <Col
                                        xl={4}
                                        lg={6}
                                        md={12}
                                        sm={12}
                                        className="pastEventsCol align-items-sm-center justify-sm-content-center d-flex flex-column align-items-xl-start"
                                    >
                                        <h3 className="text-md-center ml-3 upcomingTitle">
                                            Upcoming Events
                                        </h3>
                                        <div className="upcomingEventsList d-flex flex-column justify-content-center align-items-sm-start align-items-md-start align-items-lg-start align-items-xl-start">
                                            {Events.filter(
                                                (event) =>
                                                    event.end >= Date.now(),
                                            )
                                                .sort((a, b) => {
                                                    return a.start - b.start;
                                                })
                                                .slice(0, 4)
                                                .map((event) => (
                                                    <Link
                                                        to="/newsandevents"
                                                        key={event.title}
                                                    >
                                                        {" "}
                                                        <UpcomingEvents
                                                            title={event.title}
                                                            startDate={
                                                                event.start
                                                            }
                                                            endDate={event.end}
                                                        ></UpcomingEvents>
                                                    </Link>
                                                ))}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        <Col
                            xl={4}
                            lg={4}
                            className="pastEventsCol align-items-sm-center justify-sm-content-center d-flex flex-column align-items-xl-start"
                        >
                            <h3 className="text-md-center ml-3">Past Events</h3>
                            <div className="pastEvents d-flex flex-column justify-content-center align-items-sm-center align-items-md-center align-items-lg-start align-items-xl-start">
                                {Events.filter(
                                    (event) => event.end < Date.now(),
                                )
                                    .sort((a, b) => {
                                        return b.start - a.start;
                                    })
                                    .slice(0, 4)
                                    .map((event) => (
                                        <Link
                                            to="/newsandevents"
                                            key={event.title}
                                        >
                                            {" "}
                                            <UpcomingEvents
                                                title={event.title}
                                                startDate={event.start}
                                                endDate={event.end}
                                            ></UpcomingEvents>
                                        </Link>
                                    ))}
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className="home-section">
                <div className="home-col-title">
                    <h1>Together we can make a Difference</h1>
                    <p>
                        No matter how old you are, where you live, or what you
                        can give, you can help those in need.
                    </p>
                    <div />
                </div>
                <Row>
                    {homeColumn.map(function (items) {
                        return (
                            <HomeColumn
                                key={items.title}
                                title={items.title}
                                paragraph={items.paragraph}
                                image={items.imageLink}
                                alt={items.alt}
                                link={items.link}
                            />
                        );
                    })}
                </Row>
            </div>

            {/* Phases */}
            <Phases />

            <div className="home-video container-fluid">
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        width: "100%",
                        padding: "0",
                        margin: "0",
                    }}
                >
                    <source src={homeVideo} type="video/mp4" />
                </video>
                <div className="home-overlay">
                    <div className="home-text">
                        <h1>Learn more about us</h1>
                        <p>
                            Check out our full image and video gallery
                            <Link to="/newsandevents">
                                <span className="pl-1">
                                    <FaArrowRight></FaArrowRight>
                                </span>
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
